import { render, staticRenderFns } from "./RolesPopForm.vue?vue&type=template&id=091d9dad&"
import script from "./RolesPopForm.vue?vue&type=script&lang=js&"
export * from "./RolesPopForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports